import React from 'react';
import MessageItem from './MessageItem';
import MessageListInitialLoader from './MessageListInitialLoader';
import MessageLoadingState from './MessageLoadingState';

export default function MessageList({
  messages,
  isLoading,
  messagesEndRef,
  isDarkMode,
  chatSessionId = '',
  isResearchMode,
  researchStep,
  loading,
  isStreamingResponse,
  resources,
}) {
  if (loading) {
    return <MessageListInitialLoader isDarkMode={isDarkMode} />;
  }

  return (
    <div className="overflow-x-clip px-1 scrollbar-thin scrollbar-thumb-gray-400 scrollbar-track-transparent">
      <div className="max-w-4xl mx-auto pb-4">
        {messages.map((message, index) => (
          <MessageItem
            key={message.id}
            message={message}
            index={index}
            messages={messages}
            isDarkMode={isDarkMode}
            chatSessionId={chatSessionId}
            resources={resources}
            isResearchMode={isResearchMode}
            researchStep={researchStep}
          />
        ))}

        <div ref={messagesEndRef} />

        {isLoading && (
          <MessageLoadingState
            isDarkMode={isDarkMode}
            isResearchMode={isResearchMode}
            researchStep={researchStep}
          />
        )}
      </div>
    </div>
  );
}
